import { render, staticRenderFns } from "./ManningReport.vue?vue&type=template&id=a6a10c96&scoped=true"
import script from "./ManningReport.vue?vue&type=script&lang=js"
export * from "./ManningReport.vue?vue&type=script&lang=js"
import style0 from "./ManningReport.vue?vue&type=style&index=0&id=a6a10c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a10c96",
  null
  
)

export default component.exports